import styled from 'styled-components';

import { Tag, Button, Text } from '@gympass/yoga';

export const HeaderInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 40px ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.xxsmall}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const HeaderLabel = styled(Text.H4)`
  display: flex;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const HeaderUserProfileTag = styled(Tag.Informative)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const TooltipTextContainer = styled.div`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.bold};
`;

export const ButtonsContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const HeaderButtonChat = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px
    ${({ theme }) => theme.yoga.spacing.small}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  max-height: 32px;

  svg {
    height: 14px;
    width: 14px;
  }
`;

export const HeaderButtonDocDownload = styled(Button.Text).attrs({
  as: HeaderButtonChat,
})`
  margin-left: auto;
  margin-right: 40px;
`;
